import scooter_1 from "../../assets/vectors/scooter-1.svg";
import scooter_2 from "../../assets/vectors/scooter-2.svg";
import scooter_3 from "../../assets/vectors/scooter-3.svg";
import scooter_4 from "../../assets/vectors/scooter-4.svg";

import mobilet_1 from "../../assets/vectors/mobilet-1.svg";
import mobilet_2 from "../../assets/vectors/mobilet-2.svg";
import mobilet_3 from "../../assets/vectors/mobilet-3.svg";
import mobilet_4 from "../../assets/vectors/mobilet-4.webp";

import moped_1 from "../../assets/vectors/moped-1.svg";
import moped_2 from "../../assets/vectors/moped-2.svg";
import moped_3 from "../../assets/vectors/moped-3.svg";
import moped_4 from "../../assets/vectors/moped-4.svg";
import moped_5 from "../../assets/vectors/moped-5.webp";

import onboarding_1 from "../../assets/vectors/onboarding-1.webp";
import onboarding_2 from "../../assets/vectors/onboarding-2.webp";
import onboarding_3 from "../../assets/vectors/onboarding-3.webp";
import onboarding_4 from "../../assets/vectors/onboarding-4.webp";

import onboarding_1_dark from "../../assets/vectors/dark/onboarding-1.webp";
import onboarding_2_dark from "../../assets/vectors/dark/onboarding-2.webp";
import onboarding_3_dark from "../../assets/vectors/dark/onboarding-3.webp";
import onboarding_4_dark from "../../assets/vectors/dark/onboarding-4.webp";

import h1 from "../../assets/vectors/h1.png";
import h2 from "../../assets/vectors/h2.png";
import h3 from "../../assets/vectors/h3.png";
import h4 from "../../assets/vectors/h4.png";

import r1 from "../../assets/vectors/r1.svg";
import r2 from "../../assets/vectors/r2.svg";
import r3 from "../../assets/vectors/r3.svg";
import r4 from "../../assets/vectors/r4.svg";

import p1 from "../../assets/vectors/p1.webp";
import p2 from "../../assets/vectors/p2.webp";
import p3 from "../../assets/vectors/p3.webp";

import p1_dark from "../../assets/vectors/dark/p1.webp";
import p2_dark from "../../assets/vectors/dark/p2.webp";
import p3_dark from "../../assets/vectors/dark/p3.webp";

import do_1 from "../../assets/driver-onboarding/do-1.webp";
import do_2 from "../../assets/driver-onboarding/do-2.webp";
import do_3 from "../../assets/driver-onboarding/do-3.webp";
import do_4 from "../../assets/driver-onboarding/do-4.webp";
import do_5 from "../../assets/driver-onboarding/do-5.webp";
import do_6 from "../../assets/driver-onboarding/do-6.webp";
import do_7 from "../../assets/driver-onboarding/do-7.webp";
import do_8 from "../../assets/driver-onboarding/do-8.webp";
import do_9 from "../../assets/driver-onboarding/do-9.webp";
import do_10 from "../../assets/driver-onboarding/do-10.webp";
import do_11 from "../../assets/driver-onboarding/do-11.webp";
import do_12 from "../../assets/driver-onboarding/do-12.webp";
import do_13 from "../../assets/driver-onboarding/do-13.webp";
import do_14 from "../../assets/driver-onboarding/do-14.webp";
import do_15 from "../../assets/driver-onboarding/do-15.webp";

import do_1_dark from "../../assets/driver-onboarding/dark/do-1-dark.webp";
import do_2_dark from "../../assets/driver-onboarding/dark/do-2-dark.webp";
import do_3_dark from "../../assets/driver-onboarding/dark/do-3-dark.webp";
import do_4_dark from "../../assets/driver-onboarding/dark/do-4-dark.webp";
import do_5_dark from "../../assets/driver-onboarding/dark/do-5-dark.webp";
import do_6_dark from "../../assets/driver-onboarding/dark/do-6-dark.webp";
import do_7_dark from "../../assets/driver-onboarding/dark/do-7-dark.webp";
import do_8_dark from "../../assets/driver-onboarding/dark/do-8-dark.webp";
import do_9_dark from "../../assets/driver-onboarding/dark/do-9-dark.webp";
import do_10_dark from "../../assets/driver-onboarding/dark/do-10-dark.webp";
import do_11_dark from "../../assets/driver-onboarding/dark/do-11-dark.webp";
import do_12_dark from "../../assets/driver-onboarding/dark/do-12-dark.webp";
import do_13_dark from "../../assets/driver-onboarding/dark/do-13-dark.webp";
import do_14_dark from "../../assets/driver-onboarding/dark/do-14-dark.webp";
import do_15_dark from "../../assets/driver-onboarding/dark/do-15-dark.webp";

import { useModuleContext } from "../context/module-context";
import { useEffect } from "react";
import preloadImages from "../utils/preloadImages";

export default function ModuleImagePreloader() {
  const { currentModuleNumber } = useModuleContext();
  let images = [];

  useEffect(() => {
    if (currentModuleNumber === 1) {
      images = [scooter_1, scooter_2, scooter_3, scooter_4, r1, r2, r3, r4];
      images.push(h1, h2, h3, h4);
    }
    if (currentModuleNumber === 2) {
      images = [mobilet_1, mobilet_2, mobilet_3, mobilet_4];
      images.push(h1, h2, h3, h4);
    }
    if (currentModuleNumber === 3) {
      images = [moped_1, moped_2, moped_3, moped_4, moped_5];
      images.push(h1, h2, h3, h4);
    }
    if (currentModuleNumber === 4) {
      images = [
        onboarding_1,
        onboarding_2,
        onboarding_3,
        onboarding_4,
        onboarding_1_dark,
        onboarding_2_dark,
        onboarding_3_dark,
        onboarding_4_dark,
        p1,
        p2,
        p3,
        p1_dark,
        p2_dark,
        p3_dark,
      ];
    }
    if (currentModuleNumber === 5) {
      images = [
        do_1,
        do_2,
        do_3,
        do_4,
        do_5,
        do_6,
        do_7,
        do_8,
        do_9,
        do_10,
        do_11,
        do_12,
        do_13,
        do_14,
        do_15,
        do_1_dark,
        do_2_dark,
        do_3_dark,
        do_4_dark,
        do_5_dark,
        do_6_dark,
        do_7_dark,
        do_8_dark,
        do_9_dark,
        do_10_dark,
        do_11_dark,
        do_12_dark,
        do_13_dark,
        do_14_dark,
        do_15_dark,
      ];
    }
    preloadImages(images);
  }, []);
}

export const modules = [
  {
    id: "module1",
    steps: [
      {
        step: 1,
        type: "info",
        image: scooter_1,
        title: "module1:step1.title",
        description: "module1:step1.description",
      },
      {
        step: 2,
        type: "info",
        image: scooter_2,
        title: "module1:step2.title",
        description: "module1:step2.description",
      },
      {
        step: 3,
        type: "info",
        image: scooter_3,
        title: "module1:step3.title",
        description: "module1:step3.description",
      },
      {
        step: 4,
        type: "info",
        image: scooter_4,
        title: "module1:step4.title",
        description: "module1:step4.description",
      },

      {
        step: 5,
        type: "info_with_steps",
        title: "module1:step5.title",
        steps: [
          {
            title: "module1:step5.steps.1.title",
            description: "module1:step5.steps.1.description",
            image: h1,
          },
          {
            title: "module1:step5.steps.2.title",
            description: "module1:step5.steps.2.description",
            image: h2,
          },
          {
            title: "module1:step5.steps.3.title",
            description: "module1:step5.steps.3.description",
            image: h3,
          },
          {
            title: "module1:step5.steps.4.title",
            description: "module1:step5.steps.4.description",
            image: h4,
          },
        ],
      },
      {
        step: 6,
        type: "info_with_steps",
        title: "module1:step6.title",
        steps: [
          {
            title: "module1:step6.steps.1.title",
            description: "module1:step6.steps.1.description",
            image: r1,
          },
          {
            title: "module1:step6.steps.2.title",
            description: "module1:step6.steps.2.description",
            image: r2,
          },
          {
            title: "module1:step6.steps.3.title",
            description: "module1:step6.steps.3.description",
            image: r3,
          },
          {
            title: "module1:step6.steps.4.title",
            description: "module1:step6.steps.4.description",
            image: r4,
          },
        ],
      },
    ],
  },

  {
    id: "module2",
    steps: [
      {
        step: 1,
        type: "info",
        image: mobilet_1,
        title: "module2:step1.title",
        description: "module2:step1.description",
      },
      {
        step: 2,
        type: "info",
        image: mobilet_2,
        title: "module2:step2.title",
        description: "module2:step2.description",
      },
      {
        step: 3,
        type: "info",
        image: mobilet_3,
        title: "module2:step3.title",
        description: "module2:step3.description",
      },

      {
        step: 4,
        type: "info_with_steps",
        title: "module2:step4.title",
        steps: [
          {
            title: "module2:step4.steps.1.title",
            description: "module2:step4.steps.1.description",
            image: h1,
          },
          {
            title: "module2:step4.steps.2.title",
            description: "module2:step4.steps.2.description",
            image: h2,
          },
          {
            title: "module2:step4.steps.3.title",
            description: "module2:step4.steps.3.description",
            image: h3,
          },
          {
            title: "module2:step4.steps.4.title",
            description: "module2:step4.steps.4.description",
            image: h4,
          },
        ],
      },
      {
        step: 5,
        type: "info",
        image: mobilet_4,
        title: "module2:step5.title",
        description: "module2:step5.description",
      },
    ],
  },

  {
    id: "module3",
    steps: [
      {
        step: 1,
        type: "info",
        image: moped_1,
        title: "module3:step1.title",
        description: "module3:step1.description",
      },
      {
        step: 2,
        type: "info",
        image: moped_2,
        title: "module3:step2.title",
        description: "module3:step2.description",
      },
      {
        step: 3,
        type: "info",
        image: moped_3,
        title: "module3:step3.title",
        description: "module3:step3.description",
      },
      {
        step: 4,
        type: "info",
        image: moped_4,
        title: "module3:step4.title",
        description: "module3:step4.description",
      },

      {
        step: 5,
        type: "info_with_steps",
        title: "module3:step5.title",
        steps: [
          {
            title: "module3:step5.steps.1.title",
            description: "module3:step5.steps.1.description",
            image: h1,
          },
          {
            title: "module3:step5.steps.2.title",
            description: "module3:step5.steps.2.description",
            image: h2,
          },
          {
            title: "module3:step5.steps.3.title",
            description: "module3:step5.steps.3.description",
            image: h3,
          },
          {
            title: "module3:step5.steps.4.title",
            description: "module3:step5.steps.4.description",
            image: h4,
          },
        ],
      },
      {
        step: 6,
        type: "info",
        image: moped_5,
        title: "module3:step6.title",
        description: "module3:step6.description",
      },
    ],
  },

  {
    id: "module4",
    steps: [
      {
        step: 1,
        type: "info_with_steps",
        title: "module4:step1.title",
        steps: [
          {
            title: "module4:step1.steps.1.title",
            description: "module4:step1.steps.1.description",
            image: p1,
            darkImage: p1_dark,
          },
          {
            title: "module4:step1.steps.2.title",
            description: "module4:step1.steps.2.description",
            image: p2,
            darkImage: p2_dark,
          },
          {
            title: "module4:step1.steps.3.title",
            description: "module4:step1.steps.3.description",
            image: p3,
            darkImage: p3_dark,
          },
        ],
      },
      {
        step: 2,
        type: "info",
        image: onboarding_1,
        darkImage: onboarding_1_dark,
        title: "module4:step2.title",
        description: "module4:step2.description",
      },
      {
        step: 3,
        type: "info",
        image: onboarding_2,
        darkImage: onboarding_2_dark,
        title: "module4:step3.title",
        description: "module4:step3.description",
      },
      {
        step: 4,
        type: "info",
        image: onboarding_3,
        darkImage: onboarding_3_dark,
        title: "module4:step4.title",
        description: "module4:step4.description",
      },
      {
        step: 5,
        type: "info",
        image: onboarding_4,
        darkImage: onboarding_4_dark,
        title: "module4:step5.title",
        description: "module4:step5.description",
      },
    ],
  },
  {
    id: "module5",
    steps: [
      {
        step: 1,
        type: "info",
        image: do_1,
        darkImage: do_1_dark,
        title: "Müsait Duruma Geçin",
        heading:
          "Şehrin Kahramanı profilin onaylandı, TAG ailesine hoş geldin!",
        description:
          "Uygulamanın ana ekranındaki butona basarak müsait duruma geçebilirsin.\n\nUygulamayı kullanmayacağın zamanlarda ise “meşgul” moduna geçerek talep almayı durdurabilirsin.",
      },
      {
        step: 2,
        type: "info",
        image: do_2,
        darkImage: do_2_dark,
        title: "Kimlik Doğrulama",
        description:
          "Sistem, hesabının sana ait olduğunu teyit etmek için belirli aralıklarla selfie çekmeni ister.",
        subSections: [
          {
            heading: "Güvenlik Notu",
            description:
              "Hesabının yalnızca senin tarafından kullanıldığından emin olunur.",
          },
        ],
      },
      {
        step: 3,
        type: "info",
        image: do_3,
        darkImage: do_3_dark,
        title: "Araç Doğrulama",
        description:
          "Yolculuk öncesinde sistem, aracının güncel bir fotoğrafını isteyebilir.",
        subSections: [
          {
            heading: "Kontrol",
            description:
              "Yolcuların sisteme kayıtlı doğru araca binmesini sağlar ve araç kalite standartlarımızı korur.",
          },
        ],
      },
      {
        step: 4,
        type: "info",
        image: do_4,
        darkImage: do_4_dark,
        title: "Çağrıları Kabul Et",
        description:
          "Gelen çağrıları değerlendirmek için sınırlı süren var. Uygun teklifleri hızlıca onaylayarak yolculuğa başlayabilirsin.",
      },
      {
        step: 5,
        type: "info",
        image: do_5,
        darkImage: do_5_dark,
        title: "Eşleşme ve İletişim",
        description:
          "Eşleşme ekranında yolcunun konumunu görebilir, mesaj atabilir ya da arayabilirsin.",
        subSections: [
          {
            heading: "Güvenli İletişim",
            description: "Her iki tarafın da telefon numarası gizlenir.",
          },
          {
            heading: "Yol Tarifi",
            description:
              "Navigasyon butonuna basarak en hızlı rotayı görüntüleyebilirsin.",
          },
        ],
      },
      {
        step: 6,
        type: "info",
        image: do_6,
        darkImage: do_6_dark,
        title: "Eşleşme Kodunu Gir",
        description:
          "Buluşma noktasına geldiğinde, yolcunun vereceği 4 haneli kodu uygulamaya gir. Bu sayede yolculuk sorunsuz şekilde başlar.",
      },
      {
        step: 7,
        type: "info",
        image: do_7,
        darkImage: do_7_dark,
        title: "Yolculuk Sonu",
        description:
          "Varış noktasına ulaştığında yolculuğu uygulamadan sonlandır.",
        subSections: [
          {
            heading: "İpucu",
            description:
              "Yolcunun araçta herhangi bir eşya unutmadığından emin ol.",
          },
        ],
      },
      {
        step: 8,
        type: "info",
        image: do_8,
        darkImage: do_8_dark,
        title: "Yolculuğu Değerlendir",
        description:
          "Yolculuk sonunda yolcuyu değerlendirebilir ve geri bildirim verebilirsin. Yolcular da seni puanlayabilir.\n\nBu geri bildirimler, TAG topluluğunun kalitesini artırır.",
      },
      {
        step: 9,
        type: "info",
        image: do_9,
        darkImage: do_9_dark,
        title: "Puanın Önemi",
        description:
          "Puanın, yolcuların verdiği yıldızların ortalamasını yansıtır. Son 200 değerlendirmen üzerinden hesaplanır. Yüksek puan, daha fazla çağrı almanı ve öncelikli olmanı sağlar.",
        subSections: [
          {
            heading: "Aracını Temiz Tut",
            description: "Temiz bir araç, 5 yıldız alma ihtimalini artırır.",
          },
          {
            heading: "Nazik ve Saygılı Olun",
            description:
              "Güler yüzlü iletişim, daha yüksek puan almanı sağlar.",
          },
          {
            heading: "Güvenli Sürüş",
            description: "Trafik kurallarına uymak en önemli önceliktir.",
          },
        ],
      },
      {
        step: 10,
        type: "info",
        image: do_10,
        darkImage: do_10_dark,
        title: "Oranların Gücü",
        description: "Sistemdeki görünürlüğünü belirleyen iki ana oran vardır:",
        subSections: [
          {
            heading: "Çağrı Kabul Oranı",
            description:
              "Aldığın her 100 çağrıdan kaçını kabul ettiğini gösterir. Reddedilen veya cevapsız kalan çağrılar oranını düşürür. Kabul oranının düşük olması, daha az çağrı almana neden olur.",
          },
          {
            heading: "Eşleşme İptal Oranı",
            description:
              "Son 100 yolcu eşleşmen üzerinden hesaplanır. Kabul ettiğin çağrılardan kaçını iptal ettiğin bu oranı belirler. Bu yüzden kabul ettiğin çağrıları iptal etmemen önemlidir.\nOranların düştüğünde, aldığın çağrı sayısı da azalabilir!",
          },
        ],
      },
      {
        step: 11,
        type: "info",
        image: do_11,
        darkImage: do_11_dark,
        title: "Yüksek Fiyatlı Bölgeler",
        description:
          "Haritadaki renkli alanlarda fiyat çarpanları daha yüksek. Bu bölgelerde kazancın artar.",
      },
      {
        step: 12,
        type: "info",
        image: do_12,
        darkImage: do_12_dark,
        title: "Menü ve Kampanyalar",
        description:
          "Uygulama menüsünden profilini, araçlarını ve ödüllerini görüntüleyebilirsin.",
        subSections: [
          {
            heading: "Profili Gör",
            description:
              "Puanlarını ve performansını buradan takip edebilirsin.",
          },
          {
            heading: "Araçlarım",
            description:
              "Araçlarını görüntüleyebilir ya da yeni bir araç ekleyebilirsin.",
          },
          {
            heading: "Ödüller",
            description:
              "Hedefleri takip ederek ödül kazanma fırsatını yakalayabilirsin.",
          },
        ],
      },
      {
        step: 13,
        type: "info",
        image: do_13,
        darkImage: do_13_dark,
        title: "Veri Güvenliği",
        description:
          "Yolcuyla eşleştiğinde sadece ismin görünür. Araç bilgilerin ve plakan sistemde korunur.",
      },
      {
        step: 14,
        type: "info",
        image: do_14,
        darkImage: do_14_dark,
        title: "7/24 Canlı Yardım",
        description:
          "Herhangi bir sorunda, ana ekrandaki butonla canlı desteğe ulaşabilir ya da menüdeki yardım sekmesinden destek alabilirsin. Destek ekibimiz 7/24 yanında!",
      },
      {
        step: 15,
        type: "info",
        image: do_15,
        darkImage: do_15_dark,
        title: "Yola Hazırsınız!",
        description: "Kılavuzu tamamladın. İyi yolculuklar!",
      },
    ],
  },
];
